import styled from 'styled-components';
import { Recipient } from '@algoan/dashboard/model';

interface PartnerLogoProps {
  logo: Recipient['name'];
  isDisabled?: boolean;
  isSelected?: boolean;
}

export const getLogoFromPartner = (logo: Recipient['name']): string | undefined => {
  switch (logo) {
    case 'Creatis':
      return '/images/partners/creatis-logo.png';
    case 'Sygma':
      return '/images/partners/sygma-logo.png';
    case 'CGI':
      return '/images/partners/cgi-logo.png';
    case 'CFCAL':
      return '/images/partners/cfcal-logo.png';
    case 'CréditLift':
      return '/images/partners/credit-lift-logo.png';
    case 'My Money Bank':
      return '/images/partners/my-money-bank-logo.png';
    case 'La Banque Postale':
      return '/images/partners/la-banque-postale-logo.png';
    default:
      return undefined;
  }
};

export const PartnerLogo: React.FC<PartnerLogoProps> = ({ logo, isDisabled, isSelected }) => {
  const logoSrc = getLogoFromPartner(logo);

  return (
    <S.Container isSelected={isSelected}>
      {logoSrc !== undefined && <S.Img src={logoSrc} alt="logo" isDisabled={isDisabled} />}
    </S.Container>
  );
};

const S = {
  Container: styled.div<{ isSelected?: boolean }>`
    background: white;
    border-radius: 3px;
    border: 1px solid ${({ isSelected, theme }) => (isSelected ? theme.main.deepBlue : theme.iceBlue)};
    box-sizing: border-box;
    height: 24px;
    margin: 4px 4px 4px 0px;
    padding: 2px 2px;
    position: relative;
    width: 24px;
  `,
  Img: styled.img<{ isDisabled?: boolean }>`
    max-height: 16px;
    width: 16px;
    opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : '1')};
  `,
};
